module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?$!./node_modules/jquery/dist/jquery.js-exposed
// module id = 23
// module chunks = 1 2 3 5 7 8